import InviteForm from "../../components/functional-components/Forms/InviteForm";
import PageTitle from "../../components/ui-components/PageTitle/PageTitle";

function InviteMember(){
    return(
        <>
            <PageTitle>Invite Member</PageTitle>
            <InviteForm userType={'member'} />
        </>
    )
}

export default InviteMember;